import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

/* Layout */
import Layout from '@/layout'
import { L } from '@/store/L.js'


const routes = [
    { path: '/', redirect: '/overview' },

    /* Overview */
    {
        path: '/',
        component: Layout,
        children: [{
            path: 'overview',
            component: () =>
                import ('@/views/overview'),
            name: 'Overview',
            meta: {
                title: 'Overview',
            },
        }, ],
    },
    /* All WebSite List */
    // {
    // 	path: '/',
    // 	component: Layout,
    // 	children: [
    // 		{
    // 			path: 'all-website-list',
    // 			component: () => import('@/views/website'),
    // 			name: 'All WebSite List',
    // 			meta: { title: 'All WebSite List' },
    // 		},
    // 	],
    // },
    /* WebSite */
    {
        path: '/',
        component: Layout,
        children: [{
            path: 'website',
            component: () =>
                import ('@/views/website'),
            name: 'WebSites',
            meta: { title: 'WebSite' },
            children: [{
                    path: 'all-sites',
                    component: () =>
                        import ('@/views/website/all-sites'),
                    name: 'All Sites',
                    meta: { title: 'All Sites' },
                },
                {
                    path: '',
                    component: () =>
                        import ('../views/website/configure/index.vue'),
                    name: 'WebSite',
                    meta: { title: 'WebSite' },
                },
                {
                    path: 'add-site',
                    component: () =>
                        import ('../views/website/configure/add-site.vue'),
                    name: 'Add Site',
                    meta: { title: 'Add Site' },
                },
                {
                    path: '',
                    component: () =>
                        import ('../views/website/details/index.vue'),
                    name: 'Website Detail',
                    meta: { title: '' },
                    redirect: '/website',
                    children: [{
                            path: 'language-translation',
                            component: () =>
                                import (
                                    '../views/website/details/components/lan-translation.vue'
                                ),
                            name: 'Language Translation',
                            parentMenu: 'translate',
                            meta: { title: 'Language Translation', isShow: true },
                        },
                        {
                            path: 'url-translation',
                            component: () =>
                                import (
                                    '../views/website/details/components/url-translation.vue'
                                ),
                            name: 'Url Translation',
                            parentMenu: 'translate',
                            meta: { title: 'URL Translation', isShow: true },
                        },
                        // {
                        // 	path: 'visual-editor',
                        // 	component: () =>
                        // 		import(
                        // 			'../views/website/details/components/visual-editor.vue'
                        // 		),
                        // 	name: 'visual Editor',
                        // 	parentMenu: 'translate',
                        // 	meta: { title: 'Visual Editor', isShow: false },
                        // },

                        {
                            path: 'translation-analysis',
                            component: () =>
                                import ('@/views/website/details/components/tran-analysis.vue'),
                            name: 'Translation Analysis',
                            parentMenu: null,
                            meta: { title: 'Translation Analysis', isShow: false },
                        },
                        {
                            path: 'general-settings',
                            component: () =>
                                import (
                                    '../views/website/details/components/gen-settings.vue'
                                ),
                            name: 'General Settings',
                            parentMenu: 'setting',
                            meta: { title: 'General Settings', isShow: false },
                        },
                        {
                            path: 'exclusions-translation',
                            component: () =>
                                import (
                                    '../views/website/details/components/exc-translation.vue'
                                ),
                            name: 'Exclusions Translation',
                            parentMenu: 'setting',
                            meta: { title: 'Exclusions Translation' },
                        },
                        {
                            path: 'element-replace',
                            component: () =>
                                import (
                                    '../views/website/details/components/element-replace.vue'
                                ),
                            name: 'Element Replace',
                            parentMenu: 'setting',
                            meta: { title: 'Element Replace' ,isShow: false },
                        }
                        // {
                        //     path: 'collaborating-members',
                        //     component: () =>
                        //         import (
                        //             '../views/website/details/components/coll-members.vue'
                        //         ),
                        //     name: 'Collaborating Members',
                        //     parentMenu: 'setting',
                        //     meta: { title: 'Collaborating members', isShow: true },
                        // },
                    ],
                },
            ],
        }, ],
    },
    /* Subscribe */
    {
        path: '/',
        component: Layout,
        children: [{
            path: 'subscribe',
            component: () =>
                import ('@/views/subscribe'),
            name: 'Subscribe',
            meta: {
                title: 'Subscribe',
            },
            redirect: '/subscribe/plan-overview',
            children: [{
                    path: 'plan-overview',
                    component: () =>
                        import ('../views/subscribe/plan-overview.vue'),
                    name: 'Plan Overview',
                    meta: { title: 'Plan Overview' },
                },
                {
                    path: 'recharge-center',
                    component: () =>
                        import ('../views/subscribe/recharge-center.vue'),
                    name: 'Recharge Center',
                    meta: { title: 'Recharge Center' },
                },
                {
                    path: 'equity-center',
                    component: () =>
                        import ('../views/subscribe/equity-center.vue'),
                    name: 'Equity Center',
                    meta: { title: 'Discount Package' },
                },
                {
                    path: 'activity-center',
                    component: () =>
                        import ('../views/subscribe/activity-center.vue'),
                    name: 'Activity Center',
                    meta: { title: 'Activity Center' },
                },
                {
                    path: 'consumer-orders',
                    component: () =>
                        import ('../views/subscribe/consumer-orders.vue'),
                    name: 'Consumer Orders',
                    meta: { title: 'Consumer Orders' },
                },
            ],
        }, ],
    },
    /* 登录 */
    {
        path: '/sign-in',
        component: () =>
            import ('@/views/sign-in/index.vue'),
        name: 'sign-ins',
        meta: { title: 'sign-ins' },
    },
    // {
    //     path: '/overview',
    //     component: () => import('@/views/overview/index.vue'),
    //     name: 'sign-in-zh-cn',
    // },
    /* 修改密码 */
    {
        path: '/forgot-password',
        component: () =>
            import ('@/views/forgot-password'),
        name: 'forgot-password',
        meta: { title: 'forgot-password' },
    },
    /* 发送邮件 */
    {
        path: '/send-email',
        component: () =>
            import ('@/views/send-email'),
        name: 'send-email',
        meta: { title: 'send-email' },
    },
    /* 注册 */
    {
        path: '/create-account',
        component: () =>
            import ('@/views/create-account'),
        name: 'create-account',
        meta: { title: 'create-account' },
    },
    /* 通知 */
    {
        path: '/',
        component: Layout,
        children: [{
            path: 'notice',
            component: () =>
                import ('@/views/notice/index.vue'),
            meta: { title: 'Notice' },
            children: [{
                    path: '',
                    redirect: '/notice/promotions',
                },
                {
                    path: 'promotions',
                    component: () =>
                        import ('@/views/notice/promotions/index.vue'),
                    name: 'Promotions',
                    meta: { title: 'Promotions' },
                },
                {
                    path: 'notices',
                    component: () =>
                        import ('@/views/notice/notices/index.vue'),
                    name: 'Notices',
                    meta: { title: 'Notices' },
                },
                {
                    path: 'notices/notices-detail/:id',
                    component: () =>
                        import ('@/views/notice/notices/notices-detail.vue'),
                    name: 'notices-detail',
                    meta: { title: 'NoticesDetail' },
                },

                {
                    path: 'invitations',
                    component: () =>
                        import ('@/views/notice/invitations/index.vue'),
                    name: 'Invitations',
                    meta: { title: 'Invitations Notice' },
                },


            ],
        }, ],
    },
    /* 促销活动通知详情 */
    {
        path: '/',
        component: Layout,
        children: [{
            path: 'notice/promotions/:id',
            component: () =>
                import ('@/views/notice/promotion-detail/index.vue'),
            name: 'Promotions Detail',
            meta: { title: '' },
        }, ],
    },
    /* 全局搜索 */
    {
        path: '/',
        component: Layout,
        children: [{
            path: 'search',
            component: () =>
                import ('@/views/search/index.vue'),
            name: 'search',
            meta: { title: 'Search' },
            children: [{
                    path: '',
                    component: () =>
                        import ('@/views/search/result-list/index.vue'),
                    name: 'search-list',
                    meta: { title: 'Search' },
                },
                {
                    path: ':id',
                    component: () =>
                        import ('@/views/search/result-detail/index.vue'),
                    name: 'search-detail',
                    meta: { title: '' },
                },
            ],
        }, ],
    },
    /* 个人中心 */
    {
        path: '/',
        component: Layout,
        children: [{
            path: '/personal-center',
            component: () =>
                import ('@/views/personal-center/index.vue'),
            name: 'Personal Center',
            meta: { title: 'Personal Center' },
        }, ],
    }, /* 设置 */
    {
        path: '/',
        component: Layout,
        children: [{
            path: '/setings',
            component: () =>
                import ('@/views/setings/index.vue'),
            name: 'setings',
            meta: { title: 'Setings', requiresAuth: true },
        }, ],
    },
    {
        path: '/payment',
        name: 'Payment',
        component: () =>
            import ('@/views/payment/index.vue'),
        meta: {
            title: 'Payment',
            requiresAuth: false // 如果需要登录才能访问
        }
    },
    {
        path: '/payment/balance-wordpress',
        name: 'Balance Recharge',
        component: () =>
            import ('@/views/payment/balance_wordpress.vue'),
        meta: {
            title: 'Payment',
            requiresAuth: false // 如果需要登录才能访问
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    if (router.hasRoute(to.name)) {
        document.title = to.meta.title
        next()
    }
})

export default router